// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"756c413c","239":"83c0fb01","453":"1c89c5f4","455":"1cd92d40"}[chunkId] + ".chunk.js";
};